<template>
  <!-- 模板 -->
    <div class="container">
      <div class="top clearfix">
        <div class="top-left col-xs-12 col-sm-6">
          <img src="@/assets/image/pan.png" alt="">
          <span>比賽花絮</span>
        </div>

        <div class="top-right col-xs-12 col-sm-6">
          <ul>
            <li>
              <router-link to="titbits" class="is-check">比賽花絮</router-link>
            </li>
            <li>
              <router-link to="all-titbits">歷届花絮</router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- <hr> -->

      <div class="content col-xs-12">
        <div class="col-xs-12 p-title">{{title}}</div>
        <div v-for="(photo) in photoList" :key="photo.id" class="col-xs-6 p-img">
          <img :src="photo.photo_urls" alt="">
        </div>
      </div>

      <template v-if="totalPages >= 1">
        <mo-paging
          :totalPages="totalPages"
          v-on:get-list="getPhotoList">
        </mo-paging>
      </template>
    </div>

</template>

<script>
import MoPaging from '../pages'
export default {
  name: "mobileAlbum",
  components: {
    MoPaging
  },
  data () {
    return {
      allPhotoList: [],
      photoList: [],
      title: '',
      page: 0,
      totalPages: 0,  // 总页数
    }
  },
  methods: {
    // 获取照片的页数 【photoList的数组数量】
    getCount () {
      this.totalPages = this.allPhotoList.length
      // console.log(this.totalPages)
    },
    // 获取当前页的照片
    getPhotoList (page) {
      this.photoList = this.allPhotoList[page-1]
    }
  },
  created: function () {
    this.goTop()
    var that = this
    var typeId = this.$route.query.type_id
    this.$axios.get('award/album?type_id=' + typeId)
      .then(function (response) {
        let ArrayNum = 10  // 一组照片长度
        that.title = response.data.data.album_name
        var photoList = response.data.data.album
        // 新数组长度
        var dataArr = new Array(Math.ceil(photoList.length / ArrayNum))
        // 将所有照片切割成一个二维数组 【用于分页】
        for (let i = 0; i < dataArr.length; i++) {
          dataArr[i] = new Array()
          for (let j = 0; j < ArrayNum; j++) {
            let index = j + i * 10
            if (photoList.hasOwnProperty(index)) {
              dataArr[i][j] = photoList[index]
            }
          }
        }
        that.allPhotoList = dataArr
        that.$nextTick(function () {
          that.getCount()
        })
        // console.log(response.data.data)
        // console.log(that.allPhotoList)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  updated () {
    $('.p-img img').attr('preview', 2)
    this.$previewRefresh()
  }
}
</script>

<style scoped>
  .container {
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
    border-radius: 5px;
    margin-top: 60px;
    min-height: 900px;
    padding: 0px;

  }

  .container hr {
    margin-top: 0px;
    height: 5px;
    /*border: ;*/
    background: #617BE4;
  }

  .top {
    font-family: PingFangSC-Medium;
    color: #565656;
    border-bottom: 5px solid #617BE4;
    padding-bottom: 5px;
    margin-bottom: 10px;
  }
  .top .is-check{
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }
  .top .top-left {
    display: inline-block;
    margin-top: 5px
  }

  .top .top-left img {
    margin-bottom: 5px;
  }

  .top .top-left span {
    font-size: 24px;
  }

  .top .top-right {
    text-align: right;
    margin-top: 10px;
  }

  .top ul li {
    display: inline-block;
    margin-right: 20px;
    font-size: 18px;

  }

  .top ul li a {
    padding: 0px 5px;
    color: #565656;
  }

  .top ul li a:hover, .top ul li a:focus {
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }

  .p-title{
    font-size: 16px;
    color: #565656;
    padding: 0px;
  }
  .p-img{
    padding: 0px;
    text-align: center;
    margin-bottom: 15px;
  }
  .p-img img{
    /*width: 100%;*/
    /*height: 100%;*/
    width: 150px;
    height: 115px;
  }

  @media (max-width: 768px) {
    .top .top-right {
      text-align: center;
    }

    .top ul li {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/titbits/mobileAlbum.vue